$(function() {
  // Não executar o resto do script caso esteja na página incorreta
  if (!location.href.match(/quadro-de-concorrencia\/[0-9]+\/avaliar/gi)) {
    return false;
  }

  var qcFornecedores = $('[data-qcfornecedor]');
  var $changeRoundRadio = $('.js-change-round');
  var modal = $('#equalizacao-tecnica');
  $changeRoundRadio.on('ifChecked', function(event) {
    var radio = event.currentTarget;
    startLoading();
    location.href = [location.pathname, '?rodada=', radio.value].join('');
  });

  qcFornecedores.on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    startLoading();

    $.get(urlEqualizacao + this.dataset.qcfornecedor)
      .done(function(html) {
        modal.find('.modal-body').html(html);
        modal.modal('show');
      })
      .fail(function(x) {
        swal('Não encontrado', 'Quadro de Concorrência não econtrado.', 'error');
      })
      .always(function() {
        stopLoading();
      });
  });

  var chartTotalFornecedor = document.getElementById('chart-total-fornecedor');
  var chartInsumoFornecedor = document.getElementById('chart-insumo-fornecedor');

  // Não executar o resto do script caso a rodada mostrada não contenha dados
  if (!chartTotalFornecedor) {
    return false;
  }

  var labels = chartTotalFornecedor.dataset.labels.split('||');
  var values = chartTotalFornecedor.dataset.values.split('||');

  var __chartTotalFornecedor = new Chart(chartTotalFornecedor, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        label: 'Valor Total na rodada selecionada',
        data: values,
        backgroundColor: _.times(labels.length, _.partial(generateFlatColor, undefined)),
      }]
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            return 'Valor total: ' + floatToMoney(tooltipItem.yLabel);
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        xAxes: [{
              display: false
        }]
      }
    }
  });

  var chartValorInsumosFornecedor = document.getElementById('chart-valor-insumos-fornecedor');
  var label = chartValorInsumosFornecedor.dataset.labels.split('||');
  var insumos = JSON.parse(chartValorInsumosFornecedor.dataset.values);

  function getInsumoColors(insumos) {
    return _.times(_.uniq(_.map(insumos, 'insumo_id')).length, _.partial(generateFlatColor, undefined));
  }

  function getValorInsumoFornecedor(insumos, campo) {
    var colors = getInsumoColors(insumos);
    return _.uniq(insumos.map(function(insumo) {
      return insumo.insumo_id;
    })).map(function(insumo_id, key) {

      var insumos_do_fornecedor = insumos.filter(function(insumo) {
        return insumo.insumo_id === insumo_id
      })

      var precos = insumos_do_fornecedor.map(function(insumo) {
        return insumo[campo]
      });

      return {
        backgroundColor: colors[key],
        label: JSON.stringify(_.get(insumos_do_fornecedor, '0.insumo_nome')),
        data: insumos_do_fornecedor.map(function(insumo) {
          return insumo[campo]
        }),
      }

    });
  }

  var __chartValorInsumosFornecedor = new Chart(chartValorInsumosFornecedor, {
    type: 'bar',
    data: {
      labels: label,
      datasets: getValorInsumoFornecedor(insumos, 'valor_total')
    },
    options: {
      responsive: true,
      legend: {
        position: 'top',
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            var insumo = tooltipItem;
            return 'Valor total do insumo: ' + floatToMoney(tooltipItem.yLabel);
          }
        }
      },
      scales: {
          yAxes: [{
              ticks: {
                  beginAtZero: true
              }
          }],
          xAxes: [{
              display: false
          }]
      }
    }
  });

  var selectInsumoFornecedorValor = $('#filtro-valor-fornecedor');

  selectInsumoFornecedorValor.change(function(event) {
    __chartValorInsumosFornecedor.data.datasets = getValorInsumoFornecedor(insumos, event.currentTarget.value);
    __chartValorInsumosFornecedor.update();
  });

  var selectInsumo = $('#insumo');
  var ofertas = JSON.parse(chartInsumoFornecedor.dataset.data);
  var ofertasDoInsumo = _.filter(ofertas, {
    'insumo_id': parseInt(selectInsumo.val(), 10)
  });

  var maior_valor_grafico = _.max(_.map(ofertasDoInsumo, _.property('valor_total')));

  if(_.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) > maior_valor_grafico) {
      maior_valor_grafico = _.max(_.map(ofertasDoInsumo, _.property('valor_oi')));
  }

  var __chartInsumoFornecedor = new Chart(chartInsumoFornecedor, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        label: 'Insumo na rodada selecionada',
        data: _.map(ofertasDoInsumo, _.property('valor_total')),
        backgroundColor: _.times(labels.length, _.partial(generateFlatColor, undefined)),
      }]
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            return 'Valor total do insumo: ' + floatToMoney(tooltipItem.yLabel);
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            max: maior_valor_grafico + 1000
          }
        }],
        xAxes: [{
              display: false
        }]
      },
      "horizontalLine": [{
        "y": _.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) : [],
        "style": "red",
        "text": floatToMoney(_.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) : 0)
      },{
        "y": _.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) : [],
        "style": "green",
        "text": floatToMoney(_.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) : 0)
      },
      {
        "y": _.min(_.map(ofertasDoInsumo, function (obj) {
                          if(obj['valor_total'] > 0) {
                            return obj['valor_total'];
                          } else {
                            return maior_valor_grafico + 1000;
                          }
                        })
                  ),
        "style": "blue",
        "text": _.min(_.map(ofertasDoInsumo, function (obj) {
              if(obj['valor_total'] > 0) {
                return floatToMoney(obj['valor_total']);
              } else {
                return floatToMoney(maior_valor_grafico + 1000);
              }
            })
        )
      }]
    }
  });

  // Aplica linha horizontal no gráfico de chart-insumo-fornecedor
  var horizontalLinePlugin = {
    afterDraw: function(chartInstance) {
      var yScale = chartInstance.scales["y-axis-0"];
      var canvas = chartInstance.chart;
      var ctx = canvas.ctx;
      var index;
      var line;
      var style;

      if (chartInstance.options.horizontalLine) {
        for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
          line = chartInstance.options.horizontalLine[index];

          if (!line.style) {
            style = "rgba(169,169,169, .6)";
          } else {
            style = line.style;
          }

          if (line.y) {
            yValue = yScale.getPixelForValue(line.y);
          } else {
            yValue = 0;
          }

          ctx.lineWidth = 2;

          if (yValue) {
            ctx.beginPath();
            ctx.moveTo(yScale.right, yValue);
            ctx.lineTo(canvas.width, yValue);
            ctx.strokeStyle = style;
            ctx.stroke();
          }

          if (line.text) {
            if(line.style === 'blue') {
              ctx.fillStyle = style;
              ctx.fillText(line.text, 50, (yValue + ctx.lineWidth) - 17);
            } else if(line.style === 'red') {
              ctx.fillStyle = style;
              ctx.fillText(line.text, 560, (yValue + ctx.lineWidth) - 17);
            } else {
              ctx.fillStyle = style;
              ctx.fillText(line.text, 50, yValue + ctx.lineWidth);
            }
          }
        }
        return;
      };
    }
  };
  Chart.pluginService.register(horizontalLinePlugin);
// Fim da aplicação da linha horizontal no gráfico

  selectInsumo.change(function() {
    var ofertasDoInsumo = _.filter(ofertas, {
      'insumo_id': parseInt(selectInsumo.val(), 10)
    });

    __chartInsumoFornecedor.data.datasets[0] = {
      label: 'Insumo na rodada selecionada',
      data: _.map(ofertasDoInsumo, _.property('valor_total')),
      backgroundColor: _.times(labels.length, _.partial(generateFlatColor, undefined)),
    };

      maior_valor_grafico = _.max(_.map(ofertasDoInsumo, _.property('valor_total')));
    __chartInsumoFornecedor.options.scales.yAxes[0].ticks.max = maior_valor_grafico + 1000;

    __chartInsumoFornecedor.options.horizontalLine[0].y = _.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) : [];
    __chartInsumoFornecedor.options.horizontalLine[0].style = 'red';
    __chartInsumoFornecedor.options.horizontalLine[0].text = floatToMoney(_.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_oi'))) : 0);

    __chartInsumoFornecedor.options.horizontalLine[2].y = _.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) : [];
    __chartInsumoFornecedor.options.horizontalLine[2].style = 'green';
    __chartInsumoFornecedor.options.horizontalLine[2].text = floatToMoney(_.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) ? _.max(_.map(ofertasDoInsumo, _.property('valor_lpu'))) : 0);

    __chartInsumoFornecedor.options.horizontalLine[1].y = _.min(_.map(ofertasDoInsumo, function (obj) {
          if(obj['valor_total'] > 0) {
            return obj['valor_total'];
          } else {
            return maior_valor_grafico + 1000;
          }
        })
    );
    __chartInsumoFornecedor.options.horizontalLine[1].style = 'blue';
    __chartInsumoFornecedor.options.horizontalLine[1].text = _.min(_.map(ofertasDoInsumo, function (obj) {
          if(obj['valor_total'] > 0) {
            return floatToMoney(obj['valor_total']);
          } else {
            return floatToMoney(maior_valor_grafico + 1000);
          }
        })
    );

    __chartInsumoFornecedor.update();

  });

  var formFinalizar = document.getElementById('form-finalizar');

  var hasCheckedElement = _.flow([
    _.partialRight(_.map, _.property('checked')),
    _.partialRight(_.filter, Boolean),
    _.size,
    Boolean
  ]);


  $('#nova-rodada').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();

    var fornecedoresContainer = document.getElementById('fornecedores-container');

    var userCheckedOneFornecedor = hasCheckedElement(
      fornecedoresContainer.querySelectorAll('input[type="checkbox"]')
    );

    if (!userCheckedOneFornecedor) {
      swal({
        title: 'Próxima Rodada',
        text: 'Por favor, selecione pelo menos um fornecedor para permanecer na próxima rodada.',
        type: 'error',
      })

      return false;
    }

    swal({
      title: 'Gerar nova rodada?',
      text: 'Ao confirmar não será possível voltar atrás',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Gerar',
      cancelButtonText: 'Cancelar',
      closeOnConfirm: false,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#7ED32C'
    }, function() {

      $(formFinalizar).append('<input type="hidden" name="gerar_nova_rodada" value="1">');
      formFinalizar.submit();
    });
  });


  $('#finalizar').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();

    var getInsumosNaoSelecionados = _.flow([
      _.partialRight(_.pickBy, _.partial(_.isEqual, false)),
      _.keys
    ]);

    var rows = document.getElementsByClassName('js-insumo-row');

    var insumos = _.reduce(rows, function(insumos, row) {
      var insumo = row.querySelector('td').innerText;
      var inputs = row.querySelectorAll('input[type="radio"]');

      insumos[insumo] = hasCheckedElement(inputs);

      return insumos;
    }, {});

    var notSelected = getInsumosNaoSelecionados(insumos);

    if (notSelected.length) {
      swal({
        title: 'Selecionar vencedor',
        customClass: 'custom-alert',
        text: '<p>Por favor, selecione o vencedor dos seguintes insumos:</p>' +
          '<ul class="list-group"><li class="list-group-item">' +
          notSelected.join('</li><li class="list-group-item">') +
          '</li></ul>',
        type: 'error',
        html: true,
      })

      return false;
    }

    swal({
      title: 'Finalizar quadro de concorrência?',
      text: 'Ao confirmar não será possível voltar atrás',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Finalizar',
      cancelButtonText: 'Cancelar',
      closeOnConfirm: false,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#7ED32C'
    }, function() {
      formFinalizar.submit();
    });
  });

});

